/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2020/3/17
 * Time: 13:27
 * Desc: 新增/编辑直播
 */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
@Component
export default class GoodsLink extends Vue {
  @Prop({ default: '' })
    type: string;

  @Prop({ default: false })
    selectOne: boolean;

  @Prop({ default: null })
    goodsInfo;

  @Prop({ default: false })
    selectDisabled: boolean;

  @Prop({ default: () => {} })
    params: ItemObject;

  get btnDisabled() {
    return this.type === 'select' ? !(this.goodsList.length && this.goodsList.some(i => i.select)) : false;
  }
  /* 数据 */

  public select = '1';

  public isCheckedAll = false;
  /**
   * loading是否显示
   * @type {boolean}
   */
  public isLoadingShow = false;

  /**
   * 商品列表
   * @type {Array<VideoGoodsList>}
   */
  public goodsList: Array<VideoGoodsList> = [];
  public goodsListForExcel: Array<VideoGoodsList> = [];

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 错误图片
   * @type {any}
   */
  public errorImg: any = require('../../../../static/img/boxBgImg.svg');

  /* 方法 */

  @Watch('goodsList', { deep: true, immediate: true })
  onGoodsListChange(n, o) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (n && JSON.stringify(n)! == JSON.stringify(o)) {
      let selectLength = 0;

      n.forEach((i) => {
        if (i.select) {
          selectLength++;
        }
      });

      this.isCheckedAll = selectLength === n.length;
    }
  }

  onSelectedAll() {
    const goodsList = this.goodsList.map((i) => {
      i.select = this.isCheckedAll;
      return i;
    });
    this.$nextTick(() => {
      this.$set(this, 'goodsList', goodsList);
    });
  }

  /**
   * 获取商品列表
   * @returns null
   */
  public onGetGoodsList(): void {
    if (!this.keywords) {
      this.$message.error('请输入货号');
      return;
    }
    let productCodes = this.keywords.trim();
    productCodes = productCodes.replaceAll('，', ',');
    let temList = productCodes.split(',');
    temList = temList.filter((item) => {
      item = item.trim();
      return !!item;
    });
    temList = temList.slice(0, 50); // 最多50个

    // 检查重复货号
    // let dupArr = []; // 重复货号的数组
    // temList.forEach(item => {
    //   let count = 0;
    //   temList.forEach(sItem => {
    //     if(item === sItem){
    //       count ++;
    //       if(count>1 && dupArr.indexOf(item) === -1){
    //         dupArr.push(item);
    //       }
    //     }
    //   })
    // });
    // if(dupArr.length > 0){
    //   this.$message.error(`存在${dupArr.length}个重复货号:${dupArr.join()}`);
    //   return;
    // }

    this.isLoadingShow = true;
    const postParams = Object.assign({ ...this.params }, { productCodes: temList.join() });
    this.goodsInfo
      ? IPSService.productInfo({ postParams: Object.assign({ ...this.params }, { productCode: temList.join() }) }).then(
        (res) => {
          if (res) {
            this.goodsList = ([res] || []) as any;

            if (this.type === 'select') {
              this.goodsList = this.goodsList.map((i: any) => {
                i.select = false;
                i.productOriginPrice = i.originPrice || i.skuItems[0].originPrice;
                i.productImage = i.productImage || i.productImages[0];
                return i;
              });
              this.isCheckedAll = false;
            }
            this.isLoadingShow = false;
          }
        },
        () => {
          this.isLoadingShow = false;
        },
      )
      : IPSService.liveViewProductUrl({ postParams })
        .then((res) => {
          if (res.errorProductCode) {
            this.$message.warning({
              message: `${res.errorProductCode}货号不存在`,
              type: 'warning',
              showClose: true,
              duration: 5000,
            });
          }
          if (res.list.length > 0) {
            res.list = res.list.filter((item) => {
              return !!item.productCode;
            });
          }
          this.goodsList = res.list || [];

          if (this.type === 'select') {
            this.goodsList = this.goodsList.map((i) => {
              i.select = false;
              return i;
            });
            this.isCheckedAll = false;
          }
          this.goodsListForExcel = JSON.parse(JSON.stringify(res.list)) || [];
          this.goodsListForExcel.forEach((item, index) => {
            item['id'] = index + 1;
          });
          this.isLoadingShow = false;
        })
        .catch(() => {
          this.isLoadingShow = false;
        });
    productCodes = null;
    temList = null;
  }

  handleCheckBoxChange(index?) {
    let goodsList: any = cloneDeep(this.goodsList);

    if (this.selectOne) {
      goodsList = goodsList.map((v, i) => {
        v.select = index === i ? v.select : false;
        return v;
      });
    }

    this.$set(this, 'goodsList', goodsList);
  }

  onGoodsLinkPopSave() {
    const select = this.goodsList.filter(i => i.select);

    this.$emit('select', select);

    this.$nextTick(() => {
      this.goodsList = [];
      this.keywords = '';
      this.isCheckedAll = false;

      this.$emit('closeHandle');
    });
  }

  /**
   * 关闭弹窗
   * @returns null
   */
  public onGoodsLinkPopHide(): void {
    this.$emit('closeHandle');
    this.$emit('cancel');
  }

  /**
   * 重新生成图片
   * @param { number } index
   * @returns null
   */
  public reCreateImgSrc(index: number): void {
    this.goodsList[index].productImage = this.errorImg;
  }

  /**
   * 下载为excel
   * @returns null
   */
  public onDownLoad(): void {
    if (this.goodsListForExcel.length > 0) {
      Functions.excelMaker({
        columns: [
          { header: 'ID', key: 'id', width: 5 },
          { header: '主图', key: 'productImage', width: 60 },
          { header: '货号', key: 'productCode', width: 15 },
          { header: '商品名称', key: 'productName', width: 20 },
          { header: '牌价', key: 'productOriginPrice', width: 10 },
          { header: '商品链接', key: 'productUrl', width: 40 },
        ],
        data: this.goodsListForExcel,
        name: '直播商品',
      });
    }
  }

  /**
   * 拷贝url
   * @param {string} url
   */
  public onCopyUrl(url: string) {
    Functions.clickCopy(url, '商品链接拷贝成功');
  }

  /**
   * 清除组件数据
   * @returns null
   * @desc 父组件调用
   */
  public clearData(): void {
    this.keywords = '';
    this.goodsList = [];
    this.goodsListForExcel = [];
  }

  /* 周期 */
}
